import {Fragment} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import PropTypes from 'prop-types'

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import CheckboxInput from '../../shared/CheckboxInput'
import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import Form from '../../shared/Form'
import OtpInput from '../../shared/OtpInput'

const TfaLogIn = ({handleSubmit, fallback, loading, error}) => {
  const methods = useForm()

  return (
    <Paper elevation={3} component='div' className='tfa-login center-layout'>
      <Typography variant='h5' color='primary'>TFA LogIn</Typography>
      <Typography variant='body1' color='primary' gutterBottom>
        Please enter the code you can see in your Authenticator App.
      </Typography>
      {error && <Alert severity='error' sx={{marginBottom: '10px'}}>{error}</Alert>}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit}>
          <OtpInput control={methods.control} />
          <CheckboxInput name='trustDevice' label='Trusted Device?' />
          <Button
            disabled={loading}
            type='submit'
            variant='contained'
            sx={{color: '#F7F7F7'}}>
            Sign In
          </Button>
        </Form>
      </FormProvider>
      <Typography variant='body2' color='primary' gutterBottom>
        Unable to access your authenticator app. <Link component='button' variant='body2' onClick={fallback}>Try another way</Link>
      </Typography>
    </Paper>
  )
}

TfaLogIn.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  fallback: PropTypes.func,
  handleSubmit: PropTypes.func
}

export default TfaLogIn